import { PageLoader } from '@/components/loading'
import { useAuth } from '@/components/users/useAuth'
import { AppChildren } from '@/router'
import { useCallback, useEffect } from 'react'

const maxRetriesEnv = import.meta.env.VITE_SERVER_MAX_RETRIES
const maxRetries = maxRetriesEnv ? Number.parseInt(maxRetriesEnv) : 3

export function App() {
  const { checkAuth, logout, loading } = useAuth()

  const checkAuthInit = useCallback(async () => {
    let retries = 0
    while (retries < maxRetries) {
      try {
        await checkAuth()
        break
      } catch (error) {
        retries++

        if (retries >= maxRetries) {
          console.error('Failed to check auth', error)
          logout()
          break
        } else {
          const delay = 2 ** retries * 1000
          await new Promise(resolve => setTimeout(resolve, delay))
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    checkAuthInit()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loading) return <PageLoader />
  return <AppChildren />
}
